// extracted by mini-css-extract-plugin
export var darkMode = "_r-0";